
import Enumerable from "linq";
import { Component, Mixins, Emit, Prop, Watch } from "vue-property-decorator";
import { Directory } from "../../../../../domain/drawing";
import { FormatReference } from "../../../../../domain/format";
import { ITreeCollapsable, ITreeExpandable } from "../../../../system";
import { ModelEditableMixin } from "../../../../system/mixins";
import { IFormatTreeSelectable } from "..";
import { ITreeSource } from "../sources";

@Component({
  components: {
  },
})
export default class FormatTreeSourceSelectableMixin extends Mixins(ModelEditableMixin) {
  data(): any {
    return {
      directories: null as Directory<string, FormatReference>[],  // ロード中判定のため初期値はnull.
    };
  }
  directories: Directory<string, FormatReference>[];

  mounted(): void {
    if (this.isReady !== false) {
      this.loadTree();
    }
  }

  @Watch("isReady")
  onIsReadyUpdated(newValue: boolean, oldValue: boolean) {
    if (newValue && !this.directories) {
      this.loadTree();
    }
  }

  async loadTree(): Promise<void> {
    if (!this.treeSource) {
      console.warn("treeSource is empty!!!");
      this.directories = [];
      return;
    }
    this.directories = null;
    await this.treeSource.getTree()
    .then(d => {
      this.directories = d;
      this.hashTableDirectoryPathForEachFormatUpdated(this.toHashTableDirectoryPathForEachFormat(this.directories));
    })
    .catch(e => {
      this.directories = [];
      const entityName = this.treeSource.entityName;
      this.$error(
        entityName + "取得失敗",
        entityName + "を読み込めませんでした。",
        e
      );
    });
  }

  @Prop({ default: false })
  isShown: boolean;

  @Prop({ default: 0 })
  loadChunkSize: number;

  @Prop({ default: null })
  isReady: boolean;

  @Prop()
  treeSource: ITreeSource<FormatReference>;

  @Prop()
  filter: (source: FormatReference | Directory<string, FormatReference>) => boolean;

  @Prop()
  folderId: string;

  @Prop({ default: false })
  shouldIgnoreChained: boolean;

  selectDefaultNode(selector: IFormatTreeSelectable): boolean {
    return (this.folderId && (0 < this.folderId.length) && selector)
      ? selector.selectDirectoryNode(this.folderId)
      : false;
  }

  @Watch("treeSource")
  onTreeSourceUpdated(newValue: ITreeSource<FormatReference>, oldValue: ITreeSource<FormatReference>): void {
    this.loadTree();
  }

  get isLoaded(): boolean {
    return (this.directories !== null);
  }

  expandSelectorTree(selector: ITreeExpandable): void {
    if (this.isLoaded && selector) {
      selector.expandTree();
    }
  }

  collapseSelectorTree(selector: ITreeCollapsable): void {
    if (this.isLoaded && selector) {
      selector.collapseTree();
    }
  }

  private toHashTableDirectoryPathForEachFormat(nodes: Directory<string, FormatReference>[], array: { [key: number]: string } = {}, basePath: string = ""): { [key: number]: string } {
    Enumerable.from(nodes).forEach(n => {
      const path = basePath + n.name;
      Enumerable.from(n.entities).forEach(e => {
        // 複数フォルダに同一フォーマットが入っている場合はカンマで区切って連結している
        array[e.id] = !!array[e.id]
          ? array[e.id] + ", " + path
          : path;
      });
      this.toHashTableDirectoryPathForEachFormat(n.nodes, array, path + " / ");
    });
    return array;
  }

  @Emit("defaultNodeSelected")
  defaultNodeSelected(): void {}

  @Emit("treeNodeSelectUpdated")
  treeNodeSelectUpdated(value: boolean): void {}

  @Emit("nodeDoubleClicked")
  nodeDoubleClicked(): void {}

  @Emit("hashTableDirectoryPathForEachFormatUpdated")
  hashTableDirectoryPathForEachFormatUpdated(value: { [key: number]: string }): void {}

  @Emit("loadCompleted")
  loadCompleted(isShown: boolean): void {}
}
